import * as Yup from "yup";
export const validationSchemaVPNSetup = Yup.object({
  virtual_private_network_secure_vpn_setup_with_i2c: Yup.string()
    .optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  virtual_private_network_secure_communication_and_connectivity_via_secure_vpn: Yup.array().when(
    "virtual_private_network_secure_vpn_setup_with_i2c",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  virtual_private_network_secure_communication_and_connectivity_via_secure_vpn_other: Yup.string().when(
    "virtual_private_network_secure_communication_and_connectivity_via_secure_vpn",
    {
      is: (options) => options && options.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});
export const validationSchemaServerToServerCommunication = Yup.object({
  server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like: Yup.string()
    .optional(),
  server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other: Yup.string().when(
    "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like",
    {
      is: (value) => value === "other",
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement: Yup.string()
    .optional(),
  server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other: Yup.string().when(
    "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement",
    {
      is: (value) => value === "other",
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});